/**
 * Editorial configs for public display + LiveScope compatibility pages.
 *
 * Compatibility verdicts, GLS 10 requirements, and component actions come from
 * the domain engine. This file only holds routes, canonical slugs, SEO copy,
 * and approved framing.
 */

export const UHD2_93SV_LVS42HD = {
  id: 'echomap-uhd2-93sv-lvs42hd',
  path: '/compatibility/echomap-uhd2-93sv/lvs42hd',
  displaySlug: 'echomap-93sv-uhd2',
  livescopeSlug: 'livescope-2-lvs42hd',
  displayShortLabel: 'UHD2 93sv',
  displayChoiceLabel: 'ECHOMAP UHD2 93sv',
  livescopeShortLabel: 'LVS42HD',
  documentTitle: 'Garmin ECHOMAP UHD2 93sv + LVS42HD Compatibility | Angler Built',
  question: 'Does the Garmin ECHOMAP UHD2 93sv Work With the LVS42HD?',
  framing:
    'Verified compatibility for this display and LiveScope pair, what the architecture needs, and current retailer offers if you need either product.',
  emptyOffersMessageDisplay:
    'No current verified retailer offers are available for the ECHOMAP UHD2 93sv yet.',
  emptyOffersMessageLivescope:
    'No current verified retailer offers are available for the LVS42HD yet.',
  relatedLinks: [
    { href: '/simple-products/echomap-93sv-uhd2', label: 'View ECHOMAP UHD2 93sv prices' },
    { href: '/simple-products/livescope-2-lvs42hd', label: 'View LVS42HD prices' },
    { href: '/comparisons/lvs42hd-vs-lvs44', label: 'Compare LVS42HD vs LVS44' },
  ],
};

export const UHD2_93SV_LVS44 = {
  id: 'echomap-uhd2-93sv-lvs44',
  path: '/compatibility/echomap-uhd2-93sv/lvs44',
  displaySlug: 'echomap-93sv-uhd2',
  livescopeSlug: 'livescope-2-lvs44',
  displayShortLabel: 'UHD2 93sv',
  displayChoiceLabel: 'ECHOMAP UHD2 93sv',
  livescopeShortLabel: 'LVS44',
  documentTitle: 'Garmin ECHOMAP UHD2 93sv + LVS44 Compatibility | Angler Built',
  question: 'Does the Garmin ECHOMAP UHD2 93sv Work With the LVS44?',
  framing:
    'Verified compatibility for this display and LiveScope pair, what the architecture needs, and current retailer offers if you need either product.',
  emptyOffersMessageDisplay:
    'No current verified retailer offers are available for the ECHOMAP UHD2 93sv yet.',
  emptyOffersMessageLivescope:
    'No current verified retailer offers are available for the LVS44 yet.',
  relatedLinks: [
    { href: '/simple-products/echomap-93sv-uhd2', label: 'View ECHOMAP UHD2 93sv prices' },
    { href: '/simple-products/livescope-2-lvs44', label: 'View LVS44 prices' },
    { href: '/comparisons/lvs42hd-vs-lvs44', label: 'Compare LVS42HD vs LVS44' },
  ],
};

export const GPSMAP_1243XSV_LVS42HD = {
  id: 'gpsmap-1243xsv-lvs42hd',
  path: '/compatibility/gpsmap-1243xsv/lvs42hd',
  displaySlug: 'gpsmap-1243xsv',
  livescopeSlug: 'livescope-2-lvs42hd',
  displayShortLabel: 'GPSMAP 1243xsv',
  displayChoiceLabel: 'GPSMAP 1243xsv',
  livescopeShortLabel: 'LVS42HD',
  documentTitle: 'Garmin GPSMAP 1243xsv + LVS42HD Compatibility | Angler Built',
  question: 'Does the Garmin GPSMAP 1243xsv Work With the LVS42HD?',
  framing:
    'Verified compatibility for this display and LiveScope pair, what the architecture needs, and current retailer offers if you need either product.',
  emptyOffersMessageDisplay:
    'No current verified retailer offers are available for the GPSMAP 1243xsv yet.',
  emptyOffersMessageLivescope:
    'No current verified retailer offers are available for the LVS42HD yet.',
  relatedLinks: [
    { href: '/simple-products/gpsmap-1243xsv', label: 'View GPSMAP 1243xsv prices' },
    { href: '/simple-products/livescope-2-lvs42hd', label: 'View LVS42HD prices' },
    { href: '/comparisons/lvs42hd-vs-lvs44', label: 'Compare LVS42HD vs LVS44' },
  ],
};

export const GPSMAP_1243XSV_LVS44 = {
  id: 'gpsmap-1243xsv-lvs44',
  path: '/compatibility/gpsmap-1243xsv/lvs44',
  displaySlug: 'gpsmap-1243xsv',
  livescopeSlug: 'livescope-2-lvs44',
  displayShortLabel: 'GPSMAP 1243xsv',
  displayChoiceLabel: 'GPSMAP 1243xsv',
  livescopeShortLabel: 'LVS44',
  documentTitle: 'Garmin GPSMAP 1243xsv + LVS44 Compatibility | Angler Built',
  question: 'Does the Garmin GPSMAP 1243xsv Work With the LVS44?',
  framing:
    'Verified compatibility for this display and LiveScope pair, what the architecture needs, and current retailer offers if you need either product.',
  emptyOffersMessageDisplay:
    'No current verified retailer offers are available for the GPSMAP 1243xsv yet.',
  emptyOffersMessageLivescope:
    'No current verified retailer offers are available for the LVS44 yet.',
  relatedLinks: [
    { href: '/simple-products/gpsmap-1243xsv', label: 'View GPSMAP 1243xsv prices' },
    { href: '/simple-products/livescope-2-lvs44', label: 'View LVS44 prices' },
    { href: '/comparisons/lvs42hd-vs-lvs44', label: 'Compare LVS42HD vs LVS44' },
  ],
};

export const COMPATIBILITY_PAGES = [
  UHD2_93SV_LVS42HD,
  UHD2_93SV_LVS44,
  GPSMAP_1243XSV_LVS42HD,
  GPSMAP_1243XSV_LVS44,
];

export function getCompatibilityPageById(id) {
  return COMPATIBILITY_PAGES.find((page) => page.id === id) || null;
}

export function getCompatibilityPageByPath(path) {
  if (!path) return null;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return COMPATIBILITY_PAGES.find((page) => page.path === normalized) || null;
}

function choiceLabel(page, kind) {
  if (kind === 'display') {
    return page.displayChoiceLabel || page.displayShortLabel;
  }
  return page.livescopeChoiceLabel || page.livescopeShortLabel;
}

/**
 * Unique display and LiveScope choices currently backed by a public pair page.
 * Does not invent combinations; landing UI must still resolve a path.
 */
export function getCompatibilityLandingChoices(pages = COMPATIBILITY_PAGES) {
  const displays = [];
  const livescopes = [];
  const seenDisplays = new Set();
  const seenLivescopes = new Set();

  for (const page of pages) {
    if (page.displaySlug && !seenDisplays.has(page.displaySlug)) {
      seenDisplays.add(page.displaySlug);
      displays.push({
        slug: page.displaySlug,
        label: choiceLabel(page, 'display'),
      });
    }
    if (page.livescopeSlug && !seenLivescopes.has(page.livescopeSlug)) {
      seenLivescopes.add(page.livescopeSlug);
      livescopes.push({
        slug: page.livescopeSlug,
        label: choiceLabel(page, 'livescope'),
      });
    }
  }

  return { displays, livescopes };
}

/**
 * Returns the existing public result path for a supported pair, or null.
 * Does not evaluate compatibility.
 */
export function getCompatibilityPathForPair(
  displaySlug,
  livescopeSlug,
  pages = COMPATIBILITY_PAGES
) {
  if (!displaySlug || !livescopeSlug) return null;
  const match = pages.find(
    (page) =>
      page.displaySlug === displaySlug && page.livescopeSlug === livescopeSlug
  );
  return match ? match.path : null;
}
